<template>
  <div ref="layout" class="page-container">
    <div class="query-title">停发货设置查询</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini" label-width="100px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="停货范围">
                    <el-select v-model="conditions.stopRange">
                      <el-option
                        v-for="item in selectDataOptions['stopDeliveryRange']"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="营销中心">
                    <el-select
                      v-model="conditions.saleCenter"
                      placeholder="请选择"
                      type="select"
                      clearable
                    >
                      <el-option
                        v-for="item in saleList"
                        :key="item.SOBID"
                        :value="item.SOBID"
                        :label="item.MC_SHORT"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="品牌">
                    <el-select v-model="conditions.brand" clearable>
                      <el-option
                        v-for="item in selectDataOptions['A0019']"
                        :key="item.value"
                        :value="item.value"
                        :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="状态">
                    <el-select v-model="conditions.status" clearable>
                      <el-option
                        v-for="item in selectDataOptions['A0070']"
                        :key="item.value"
                        :value="item.value"
                        :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="8">
                  <el-form-item label="区域">
                    <el-select v-model="conditions.area" clearable>
                      <el-option
                        v-for="item in selectDataOptions['province']"
                        :key="item.cityNo"
                        :value="item.cityNo"
                        :label="item.cityName"
                      />
                    </el-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="8">
                  <el-form-item label="经销商">
                    <!-- <el-input
                      v-model="conditions.dealersName"
                      suffix-icon="el-icon-more"
                      clearable
                      @focus="openDialog($event, '客户选择')"
                    /> -->
                    <wly-input v-model="conditions.dealersName" input-type="customer" @enter="handleEnter" @handleSuffixClick="openDialog($event, '客户选择')" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="申请日期从">
                    <el-date-picker
                      v-model="conditions.createdStartDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="到">
                    <el-date-picker
                      v-model="conditions.createdEndDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData(1)">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="明细"
          export-all
          export-page
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :custome-config="() => vxeShowCustom('xTable')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @exportExcel="exportExcel"
        >
          <template #button>
            <table-button name="add" tip="新增" @click="$emit('change-mode', 'edit')" />
            <table-button name="export" tip="关闭" @click="openCloseDialog" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
              <span :key="item.field">{{ row[item.field] }}</span>
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      :append-to-body="true"
      :title="dialogTitle"
      width="70%"
    >
      <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
      <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />
      <div slot="footer">
        <el-button size="small" type="default" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="closeDialogVisible"
      title="关闭原因"
      width="480px"
      :close-on-click-modal="false"
      @close="cancelCloseDialog"
    >
      <el-form label-width="80px" size="mini">
        <el-form-item label="关闭原因">
          <el-input
            v-model="closeRemark"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入关闭原因"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" type="default" @click="cancelCloseDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="closeSubmitting" @click="submitCloseStatus">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { exportExcel } from '@/utils/excelExport.js'
import { findCityArea } from '@/api/contract'
import { findStopShippingList, apiStopdeliveryCloseStatus } from '@/api/applyForGoods/index'
import ClientSelect from '@/components/dialog/ClientSelect'
import OrgSelect from '@/components/dialog/OrgSelect'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

export default {
  name: 'delivery-setting-list',
  components: {
    ClientSelect,
    OrgSelect
  },
  data() {
    return {
      showDialog: false,
      dialogTitle: '',
      closeDialogVisible: false,
      closeSelectedIds: [],
      closeRemark: '',
      closeSubmitting: false,
      conditions: {
        stopRange: '',
        saleCenter: '',
        dealers: '',
        dealersName: '',
        createdStartDate: '',
        saleCenterName: '',
        createdEndDate: '',
        brand: '',
        area: ''
      },
      selectDataOptions: {},
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      saleList: [],
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          {
            field: 'stopRangeTextView',
            title: '停货范围',
            width: 110,
            slots: { default: 'stopRangeTextView' },
            editRender: { name: 'input' }
          },
          {
            field: 'saleCenterName',
            title: '营销中心',
            width: 170,
            slots: { default: 'saleCenterName' },
            editRender: { name: 'input' }
          },
          {
            field: 'baseName',
            title: '基地',
            width: 170,
            slots: { default: 'baseName' },
            editRender: { name: 'input' }
          },
          {
            field: 'dealerName',
            title: '经销商',
            width: 250,
            slots: { default: 'dealerName' },
            editRender: { name: 'input' }
          },
          {
            field: 'brandName',
            title: '存货分类',
            width: 150,
            slots: { default: 'brandName' },
            editRender: { name: 'input' }
          },
          {
            field: 'effectiveStartDate',
            title: '生效开始日期',
            width: 110,
            slots: { default: 'effectiveStartDate' },
            editRender: { name: 'input' }
          },
          {
            field: 'effectiveEndDate',
            title: '生效截止日期',
            width: 110,
            slots: { default: 'effectiveEndDate' },
            editRender: { name: 'input' }
          },
          {
            field: 'statusTextView',
            title: '状态',
            width: 80,
            slots: { default: 'statusTextView' },
            editRender: { name: 'input' }
          },
          {
            field: 'createdByName',
            title: '申请人',
            width: 120,
            slots: { default: 'createdByName' },
            editRender: { name: 'input' }
          },
          {
            field: 'stopReason',
            title: '停发货原因',
            width: 200,
            slots: { default: 'stopReason' },
            editRender: { name: 'input' }
          },
          {
            field: 'remark',
            title: '备注',
            width: 200,
            slots: { default: 'remark' },
            editRender: { name: 'input' }
          }
        ],
        data: []
      }
    }
  },
  created() {
    this.init()
    apiGetOrgOrBase().then(res => {
      this.saleList = res.DATA
    })
  },
  methods: {
    init() {
      this.getSelectDictDataOrigin('A0019')
      this.getSelectDictDataOrigin('A0070')

      this.getSelectDictDataOrigin('stopDeliveryRange')

      this.getSelectDictDataOrigin('A0008')

      // this.findWlyOrg()
      this.queryData(1)

      // 初始化省份
      this.findCityArea().then(res => {
        this.$set(this['selectDataOptions'], 'province', res)
      })
    },
    openDialog(e, title) {
      e.target.blur()
      this.dialogTitle = title
      this.showDialog = true
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        if (this.dialogTitle === '客户选择') {
          this.conditions.dealers = data.partner
          this.conditions.dealersName = data.customerName
        } else {
          this.conditions.saleCenter = data.code
          this.conditions.saleCenterName = data.name
        }
      }
      this.showDialog = false
    },
    openCloseDialog() {
      const records = this.$refs.xTable.getCheckboxRecords()
      if (!records.length) {
        this.$message.warning('请选择有效数据！')
        return
      }
      this.closeSelectedIds = records.map(item => item.id)
      this.closeRemark = ''
      this.closeDialogVisible = true
    },
    async submitCloseStatus() {
      if (!this.closeRemark || !this.closeRemark.trim()) {
        this.$message.warning('请输入关闭原因')
        return
      }
      const formData = new FormData()
      formData.append('ids', this.closeSelectedIds.join(','))
      formData.append('remark', this.closeRemark.trim())

      this.closeSubmitting = true
      try {
        const res = await apiStopdeliveryCloseStatus(formData)
        if (res.status === 1) {
          this.$message.success('操作成功！')
          this.closeDialogVisible = false
          this.closeRemark = ''
          this.closeSelectedIds = []
          if (this.$refs.xTable) {
            this.$refs.xTable.clearCheckboxRow()
          }
          this.queryData()
        }
      } catch (error) {
        //
      } finally {
        this.closeSubmitting = false
      }
    },
    cancelCloseDialog() {
      this.closeDialogVisible = false
      this.closeRemark = ''
      this.closeSelectedIds = []
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 获取区域
    async findCityArea(parentId = 0) {
      const {
        data: { Rows }
      } = await findCityArea({ parentId })
      return Rows
    },
    // 处理分页事件
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.queryData()
    },
    async queryData(page) {
      if (page) {
        this.pagination.page = page
      }
      this.loading = true
      const params = {
        ...this.conditions,
        ...this.pagination
      }

      try {
        const {
          data: { Rows, Total }
        } = await findStopShippingList(params)

        if (Rows.length === 0 && Total) {
          this.queryData(1)
          return
        }
        this.gridOptions.data = Rows
        this.pagination.totalCount = Total
      } catch (e) {
        //
      }
      this.loading = false
    },
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList ? (this.errorList = [type.message]) : this.$message.error(type.message)
        return
      }
      if (!data) return
      this.conditions.dealers = data.partner
      this.conditions.dealersName = data.customerName
    },
    exportExcel(type) {
      const { page, pagesize } = this.pagination
      const columns = this.gridOptions.columns.filter(v => !v.type)
      const params = {
        columns: columns,
        requestParams: {
          exportType: type,
          page,
          pagesize,
          ...this.conditions
        },
        api: findStopShippingList,
        isConvertColumns: true
      }
      exportExcel(params, '停发货设置')
    },
    reset() {
      this.conditions = {
        stopRange: '',
        saleCenter: '',
        saleCenterName: '',
        dealers: '',
        dealersName: '',
        createdStartDate: '',
        createdEndDate: '',
        brand: ''
        // area: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/components/DeliverySettingList.vue